module.exports = __webpack_public_path__ + "static/media/svg-loader.46246d23.svg";